import PropTypes from 'prop-types';
export const MaintenanceScreenDefaultProps = {
    description: '',
    footnote: '',
};
export const MaintenanceScreenPropTypes = {
    description: PropTypes.string,
    imageComponent: PropTypes.node,
    title: PropTypes.string.isRequired,
    footnote: PropTypes.string.isRequired
};
//# sourceMappingURL=MaintenanceScreen.PropTypes.js.map